module.exports = __webpack_public_path__ + "static/img/sq1.52ab98f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sq1.png
// module id = gEZc
// module chunks = 1